<template>
    <div class="myheader">
            <a 
            v-for="item in urlList" 
            :key="item" 
            :href="item.url">
                <div class="headerLink">
                    {{item.name}}
                </div>
            </a>
        <el-button type="primary" plain class="btn" @click="gotosign">登录/注册</el-button>
    </div>
</template>

<script>
export default {
    name:'MyHeader',
    data(){
        return{
            urlList:[
                {url:'./',name:'首页'},
                {url:'./table.html',name:'表格'},
                {url:'./findmusic/index.html',name:'播放器'},
                {url:'./about.html',name:'关于'},
            ]
        }
    },
    methods:{
        gotosign(){
            location.href = './sign.html'
        },
    }
}
</script>

<style>
    .myheader{
        background-color: rgb(206, 232, 255);
        height: 3em;
        padding: 0.5em 1em 0em 1em;
        border-radius: 0.5em;
    }

    .headerLink{
        float:left;
        width: 4em;
        height: 1.5em;
        margin-top: -0.5em;
        padding: 1em 1em 1em 1em;

        border-radius: 0.4em;
        font-weight: 600;
        color:#000;
    }

    .headerLink:hover{
        background-color: rgb(230, 243, 255);
    }

    .btn{
        float:right;
    }
</style>